import { useEffect, useMemo, useRef, useState } from "react"
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import Style from "./style";

function useOutsideAlerter({ ref, secondRef, onOutside = () => { } }) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)
        && secondRef.current && !secondRef.current.contains(event.target)) {
        onOutside();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const Options = ({
  values = [],
  onChange = () => { },
  value = '',
  setToggled = () => { },
  toggled = false,
  secondRef = {},
}) => {
  const ref = useRef();
  useOutsideAlerter({ ref, secondRef, onOutside: () => setToggled(false) });

  return (
    <div
      className={formatClassname(['select-options', !toggled && 'not-toggled'])}
      ref={ref}
    >
      {values.map((val) => (
        <div
          className={formatClassname(['value', val.value === value && 'active-value'])}
          key={val.value}
          onClick={() => onChange(val.value)}
        >
          {val.label}
        </div>
      ))}
    </div>
  );
}

let timeout = null;

export const Select = ({
  bordered,
  values = [],
  defaultValue = '',
  onChange = () => { },
}) => {
  const ref = useRef();
  const [value, setValue] = useState(defaultValue);
  const [toggled, setToggled] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const valueLabel = useMemo(() => {
    if (value === 'en') {
      return (
        <div className="country-cont flex-r">
          <div className="flex-c jus-c">
            <img src="/assets/images/countries/gb.png" alt="" />
          </div>
          <div className="flex-c jus-c">
            <span>EN</span>
          </div>
        </div>
      );
    }

    return (
      <div className="country-cont flex-r">
        <div className="flex-c jus-c">
          <img src="/assets/images/countries/fr.png" alt="" />
        </div>
        <div className="flex-c jus-c">
          <span>FR</span>
        </div>
      </div>
    );
  }, [values, value]);

  useEffect(() => {
    if (toggled) {
      setVisible(true);
    } else {
      timeout = setTimeout(() => setVisible(false), 300);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }
  }, [toggled]);

  return (
    <Style>
      <div
        className={formatClassname(['select-navbar', bordered && 'bordered'])}
        onClick={() => setToggled((p) => !p)}
        ref={ref}
      >
        <div>{valueLabel}</div>
      </div>
      {visible && (
        <Options
          value={value}
          secondRef={ref}
          values={values}
          toggled={toggled}
          onChange={(val) => {
            setValue(val);
            setToggled(false);
            onChange(val);
          }}
          setToggled={setToggled}
        />
      )}
    </Style>
  );
}
